import {FloatButton, Layout} from 'antd'
import React from 'react'

export const NormalLayout = ({ children, left, bottom, header }) => {
    return (
        <Layout className="NormalLayout w-full min-h-screen background" style={{ flexDirection: 'column' }}>
            {header}
            <Layout
                className="background-50 111-111"
                style={{
                    flexDirection: 'row',
                    flex: 1,
                }}>
                {left}
                {children}
            </Layout>
            {bottom}
            <FloatButton.BackTop
                style={{
                    bottom: 'calc(2 * var(--header-height) + 18px)',
                    right: 18,
                    zIndex: -1,
                }}
            />
        </Layout>
    )
}